module.exports = __webpack_public_path__ + "static/media/d3.3c22f665.png";